import RevolverWinTransitions from "./revolver-win-transitions";
import Contract from "slotworks/utils/contract";
import { parallel, sequence } from "slotworks/utils/race-utils";
import Timer from "slotworks/utils/timer";
import * as TweenJS from "slotworks/utils/tween";
import Layers from "slotworks/graphics/layers/layers";
import gameState from "slotworks/model/game-state";
import Components from "slotworks/components/components";
import soundManager from "slotworks/sound/sound-manager";
import { FadeOut } from "slotworks/graphics/animation/base-animations";
import G288Components from "components/components";

export default class EpicWinTransitions extends RevolverWinTransitions {

    private letters: PIXI.Sprite[] = [];
    private win: boolean;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.clearTimers();

            this.inResolve = resolve;
            this.letters = [...Layers.CelebrationContent.container.children] as PIXI.Sprite[];
            this.win = false;

            TweenJS.removeAll(RevolverWinTransitions.glowContainer.scale);
            new TweenJS.Tween(RevolverWinTransitions.glowContainer.scale)
            .to({x: 2.5, y: 2.5}, 400)
            .easing(TweenJS.Easing.Back.In)
            .onComplete(() => this.resolveIn())
            .start();
            RevolverWinTransitions.coins.frequency = 0.03;
            RevolverWinTransitions.coins.emit = true;
            this.setLettersAnchors(this.letters);
            this.zoomInLetters(this.letters, true, true);
            this.emphasizeText(1.2, 1.15, 1.05);
            G288Components.bigWin.totalReached.addOnce(this.onAmountReached);
            this.timers.push(Timer.setTimeout(() => {
                if(!this.win) this.scaleDownText();
            }, 2000));
        });
    }

    public skipIn() {
        G288Components.bigWin.totalReached.removeAll();
        this.clearTimers();
        this.cleanLetterTweens();
        this.cleanTextTween();
        RevolverWinTransitions.winValue.visible = true;
        RevolverWinTransitions.winValue.scale.set(1, 1);
        soundManager.customEvent("epic_win");
        RevolverWinTransitions.winValue.visible = true;
        RevolverWinTransitions.winValue.scale.set(1, 1);
        RevolverWinTransitions.glowContainer.scale.set(5, 5);
        RevolverWinTransitions.coins.emit = true;
        RevolverWinTransitions.winGlow.visible = true;
        RevolverWinTransitions.winGlow.alpha = 0.8;
        for(let i = 0; i < this.letters.length; i++) {
            TweenJS.removeAll(this.letters[i]);
            this.letters[i].scale.set(1, 1);
            this.letters[i].visible = true;
        }
        this.resolveIn();
    }

    public out(): Contract<void> {        
        return sequence([
            () => Contract.wrap(() => { 
                this.clearTimers();
                this.cleanLetterTweens();
                this.cleanTextTween();
                RevolverWinTransitions.coins.emit = false;
                TweenJS.removeAll(RevolverWinTransitions.winValue.scale);
                const totalWin = gameState.getCurrentGame().totalCreditsWon;
                Components.betBar.winnings.setWinnings(totalWin, totalWin, 750);  
                FadeOut(RevolverWinTransitions.winGlow, 500).execute();
                this.zoomOutLetters(this.letters, 400);
                this.zoomOut(RevolverWinTransitions.winValue, 400).then(() => RevolverWinTransitions.winValue.visible = false);
                RevolverWinTransitions.coins.emit = false; 
                soundManager.customEvent("plaque_exit");             
            }),             
            () => this.zoomOutStacks(),
            () => Contract.wrap(() => {
                soundManager.customEvent("celebration_end");
            }),
            () => FadeOut(RevolverWinTransitions.background, this.BOUNCE_TIME),
            () => Contract.wrap(() => this.clean()),
            () => Contract.getTimeoutContract(750)            
        ]);
    }

    public destroy() {
        this.clearTimers();

        super.destroy();
    }

    private onAmountReached = () => {
        this.win = true;
        this.emphasizeText(1.35, 1.2, 1.3);
    }
}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/epic-win-transitions.ts